import { configureStore} from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { loginReducer } from './loginSlice'
import { mainReducer } from './mainSlice'
import DianShangYeWuApi from './DianShangYeWuApi'
import ReactWebSiteApi from './ReactWebSiteApi'

const store = configureStore({
    reducer: {
        //网站       
        login: loginReducer,   
        main: mainReducer,   
        [DianShangYeWuApi.reducerPath]: DianShangYeWuApi.reducer,
        [ReactWebSiteApi.reducerPath]: ReactWebSiteApi.reducer,
        
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(
            DianShangYeWuApi.middleware,
            ReactWebSiteApi.middleware,
        ),    
    }
);

setupListeners(store.dispatch)

export default store;